import { type SVGProps } from "react";

// Icons from the onboarding Figma ("Icon / shirt", "Icon / snowflake", ...),
// drawn from the design's own stroke paths. They stroke with currentColor, so
// CSS sets the colour.
type IconData = { size: number; strokeWidth: number; paths: string[] };

const ICONS = {
  womens_tops: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M15.285 2.595L12 1.5C12 2.29565 11.6839 3.05871 11.1213 3.62132C10.5587 4.18393 9.79565 4.5 9 4.5C8.20435 4.5 7.44129 4.18393 6.87868 3.62132C6.31607 3.05871 6 2.29565 6 1.5L2.715 2.595C2.37554 2.7081 2.08768 2.93881 1.90339 3.24551C1.7191 3.5522 1.65051 3.91467 1.71 4.2675L2.145 6.87C2.17356 7.04618 2.26401 7.20641 2.40011 7.32188C2.5362 7.43736 2.70902 7.50051 2.8875 7.5H4.5V15C4.5 15.825 5.175 16.5 6 16.5H12C12.3978 16.5 12.7794 16.342 13.0607 16.0607C13.342 15.7794 13.5 15.3978 13.5 15V7.5H15.1125C15.291 7.50051 15.4638 7.43736 15.5999 7.32188C15.736 7.20641 15.8264 7.04618 15.855 6.87L16.29 4.2675C16.3495 3.91467 16.2809 3.5522 16.0966 3.24551C15.9123 2.93881 15.6245 2.7081 15.285 2.595Z",
    ],
  },
  mens_fashion: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M14.25 15.75V14.25C14.25 13.4544 13.9339 12.6913 13.3713 12.1287C12.8087 11.5661 12.0456 11.25 11.25 11.25H6.75C5.95435 11.25 5.19129 11.5661 4.62868 12.1287C4.06607 12.6913 3.75 13.4544 3.75 14.25V15.75",
      "M12 5.25C12 6.90685 10.6569 8.25 9 8.25C7.34315 8.25 6 6.90685 6 5.25C6 3.59315 7.34315 2.25 9 2.25C10.6569 2.25 12 3.59315 12 5.25Z",
    ],
  },
  dresses: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9Z",
      "M9 12.375C9 13.0425 8.80206 13.695 8.43121 14.2501C8.06036 14.8051 7.53326 15.2376 6.91656 15.4931C6.29986 15.7485 5.62126 15.8154 4.96657 15.6852C4.31188 15.5549 3.71052 15.2335 3.23851 14.7615C2.76651 14.2895 2.44507 13.6881 2.31485 13.0334C2.18462 12.3787 2.25146 11.7001 2.50691 11.0834C2.76235 10.4667 3.19493 9.93964 3.74995 9.56879C4.30497 9.19794 4.95749 9 5.625 9C4.95749 9 4.30497 8.80206 3.74995 8.43121C3.19493 8.06036 2.76235 7.53326 2.50691 6.91656C2.25146 6.29986 2.18462 5.62126 2.31485 4.96657C2.44507 4.31188 2.76651 3.71052 3.23851 3.23851C3.71052 2.76651 4.31188 2.44507 4.96657 2.31485C5.62126 2.18462 6.29986 2.25146 6.91656 2.50691C7.53326 2.76235 8.06036 3.19493 8.43121 3.74995C8.80206 4.30497 9 4.95749 9 5.625C9 4.95749 9.19794 4.30497 9.56879 3.74995C9.93964 3.19493 10.4667 2.76235 11.0834 2.50691C11.7001 2.25146 12.3787 2.18462 13.0334 2.31485C13.6881 2.44507 14.2895 2.76651 14.7615 3.23851C15.2335 3.71052 15.5549 4.31188 15.6852 4.96657C15.8154 5.62126 15.7485 6.29986 15.4931 6.91656C15.2376 7.53326 14.8051 8.06036 14.2501 8.43121C13.695 8.80206 13.0425 9 12.375 9C13.0425 9 13.695 9.19794 14.2501 9.56879C14.8051 9.93964 15.2376 10.4667 15.4931 11.0834C15.7485 11.7001 15.8154 12.3787 15.6852 13.0334C15.5549 13.6881 15.2335 14.2895 14.7615 14.7615C14.2895 15.2335 13.6881 15.5549 13.0334 15.6852C12.3787 15.8154 11.7001 15.7485 11.0834 15.4931C10.4667 15.2376 9.93964 14.8051 9.56879 14.2501C9.19794 13.695 9 13.0425 9 12.375Z",
      "M9 5.625V6.75",
      "M5.625 9H6.75",
      "M12.375 9H11.25",
      "M9 12.375V11.25",
      "M6 6L7.41 7.41",
      "M10.59 7.41L12 6",
      "M6 12L7.41 10.59",
      "M10.59 10.59L12 12",
    ],
  },
  jewelry_and_watches: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M4.5 2.25H13.5L16.5 6.75L9 16.5L1.5 6.75L4.5 2.25Z",
      "M8.25 2.25L6 6.75L9 16.5L12 6.75L9.75 2.25",
      "M1.5 6.75H16.5",
    ],
  },
  bags_and_accessories: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M4.5 1.5L2.25 4.5V15C2.25 15.3978 2.40804 15.7794 2.68934 16.0607C2.97064 16.342 3.35218 16.5 3.75 16.5H14.25C14.6478 16.5 15.0294 16.342 15.3107 16.0607C15.592 15.7794 15.75 15.3978 15.75 15V4.5L13.5 1.5H4.5Z",
      "M2.25 4.5H15.75",
      "M12 7.5C12 8.29565 11.6839 9.05871 11.1213 9.62132C10.5587 10.1839 9.79565 10.5 9 10.5C8.20435 10.5 7.44129 10.1839 6.87868 9.62132C6.31607 9.05871 6 8.29565 6 7.5",
    ],
  },
  outerwear: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M1.5 9H16.5",
      "M9 1.5V16.5",
      "M15 12L12 9L15 6",
      "M3 6L6 9L3 12",
      "M12 3L9 6L6 3",
      "M6 15L9 12L12 15",
    ],
  },
  activewear: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M10.8 10.8L7.2 7.2",
      "M13.9927 16.1137C13.7115 16.3951 13.33 16.5532 12.9321 16.5533C12.5343 16.5534 12.1527 16.3954 11.8714 16.1141C11.59 15.8329 11.4319 15.4513 11.4318 15.0535C11.4318 14.6557 11.5897 14.2741 11.871 13.9927L10.5457 15.3187C10.2644 15.6001 9.88278 15.7582 9.48487 15.7582C9.08697 15.7582 8.70536 15.6001 8.424 15.3187C8.14264 15.0374 7.98457 14.6558 7.98457 14.2579C7.98457 13.86 8.14264 13.4784 8.424 13.197L13.197 8.424C13.4784 8.14264 13.86 7.98457 14.2579 7.98457C14.6558 7.98457 15.0374 8.14264 15.3187 8.424C15.6001 8.70536 15.7582 9.08697 15.7582 9.48487C15.7582 9.88278 15.6001 10.2644 15.3187 10.5457L13.9927 11.871C14.2741 11.5897 14.6557 11.4318 15.0535 11.4318C15.4513 11.4319 15.8329 11.59 16.1141 11.8714C16.3954 12.1527 16.5534 12.5343 16.5533 12.9321C16.5532 13.33 16.3951 13.7115 16.1137 13.9927L13.9927 16.1137Z",
      "M16.125 16.125L15.075 15.075",
      "M2.925 2.925L1.875 1.875",
      "M4.803 9.576C4.52164 9.85736 4.14003 10.0154 3.74213 10.0154C3.34422 10.0154 2.96261 9.85736 2.68125 9.576C2.39989 9.29464 2.24182 8.91303 2.24182 8.51513C2.24182 8.11722 2.39989 7.73561 2.68125 7.45425L4.00725 6.129C3.86793 6.26827 3.70255 6.37873 3.52055 6.45408C3.33854 6.52943 3.14347 6.5682 2.94648 6.56816C2.54865 6.56809 2.16714 6.40999 1.88588 6.12863C1.74661 5.98931 1.63615 5.82393 1.56079 5.64192C1.48544 5.45991 1.44668 5.26485 1.44671 5.06786C1.44678 4.67002 1.60489 4.28851 1.88625 4.00725L4.00725 1.88625C4.28851 1.60489 4.67002 1.44678 5.06786 1.44671C5.26485 1.44668 5.45991 1.48544 5.64192 1.56079C5.82393 1.63615 5.98931 1.74661 6.12863 1.88588C6.26794 2.02514 6.37846 2.19049 6.45388 2.37247C6.52929 2.55444 6.56813 2.7495 6.56816 2.94648C6.5682 3.14347 6.52943 3.33854 6.45408 3.52055C6.37873 3.70255 6.26827 3.86793 6.129 4.00725L7.45425 2.68125C7.73561 2.39989 8.11722 2.24182 8.51513 2.24182C8.91303 2.24182 9.29464 2.39989 9.576 2.68125C9.85736 2.96261 10.0154 3.34422 10.0154 3.74213C10.0154 4.14003 9.85736 4.52164 9.576 4.803L4.803 9.576Z",
    ],
  },
  swimwear: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M1.5 4.5C1.95 4.875 2.4 5.25 3.375 5.25C5.25 5.25 5.25 3.75 7.125 3.75C9.075 3.75 8.925 5.25 10.875 5.25C12.75 5.25 12.75 3.75 14.625 3.75C15.6 3.75 16.05 4.125 16.5 4.5",
      "M1.5 9C1.95 9.375 2.4 9.75 3.375 9.75C5.25 9.75 5.25 8.25 7.125 8.25C9.075 8.25 8.925 9.75 10.875 9.75C12.75 9.75 12.75 8.25 14.625 8.25C15.6 8.25 16.05 8.625 16.5 9",
      "M1.5 13.5C1.95 13.875 2.4 14.25 3.375 14.25C5.25 14.25 5.25 12.75 7.125 12.75C9.075 12.75 8.925 14.25 10.875 14.25C12.75 14.25 12.75 12.75 14.625 12.75C15.6 12.75 16.05 13.125 16.5 13.5",
    ],
  },
  shoes_and_sneakers: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M3 12V10.215C3 8.625 2.2275 7.875 2.25 6C2.2725 3.96 3.3675 1.5 5.625 1.5C7.0275 1.5 7.5 2.85 7.5 4.125C7.5 6.4575 6 8.37 6 10.635V12C6 12.3978 5.84196 12.7794 5.56066 13.0607C5.27936 13.342 4.89782 13.5 4.5 13.5C4.10218 13.5 3.72064 13.342 3.43934 13.0607C3.15804 12.7794 3 12.3978 3 12Z",
      "M15 15V13.215C15 11.625 15.7725 10.875 15.75 9C15.7275 6.96 14.6325 4.5 12.375 4.5C10.9725 4.5 10.5 5.85 10.5 7.125C10.5 9.4575 12 11.37 12 13.635V15C12 15.3978 12.158 15.7794 12.4393 16.0607C12.7206 16.342 13.1022 16.5 13.5 16.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15Z",
      "M12 12.75H15",
      "M3 9.75H6",
    ],
  },
  sunglasses_and_hats: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M7.5 11.25C7.5 12.9069 6.15685 14.25 4.5 14.25C2.84315 14.25 1.5 12.9069 1.5 11.25C1.5 9.59315 2.84315 8.25 4.5 8.25C6.15685 8.25 7.5 9.59315 7.5 11.25Z",
      "M16.5 11.25C16.5 12.9069 15.1569 14.25 13.5 14.25C11.8431 14.25 10.5 12.9069 10.5 11.25C10.5 9.59315 11.8431 8.25 13.5 8.25C15.1569 8.25 16.5 9.59315 16.5 11.25Z",
      "M10.5 11.25C10.5 10.8522 10.342 10.4706 10.0607 10.1893C9.77936 9.90804 9.39782 9.75 9 9.75C8.60218 9.75 8.22064 9.90804 7.93934 10.1893C7.65804 10.4706 7.5 10.8522 7.5 11.25",
      "M1.875 9.75L3.75 5.25C4.275 4.275 4.8 3.75 6 3.75",
      "M16.125 9.75L14.25 5.25C13.725 4.275 13.125 3.75 12 3.75",
    ],
  },
  kids_fashion: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M6.75 9H6.7575",
      "M11.25 9H11.2575",
      "M7.5 12C7.875 12.225 8.4 12.375 9 12.375C9.6 12.375 10.125 12.225 10.5 12",
      "M14.25 4.725C14.9295 5.57675 15.3927 6.58033 15.6 7.65C15.8536 7.77283 16.0675 7.96461 16.2171 8.20337C16.3668 8.44213 16.4462 8.71821 16.4462 9C16.4462 9.28179 16.3668 9.55787 16.2171 9.79663C16.0675 10.0354 15.8536 10.2272 15.6 10.35C15.2762 11.8601 14.4444 13.2135 13.2433 14.1844C12.0422 15.1553 10.5444 15.6849 9 15.6849C7.45557 15.6849 5.95784 15.1553 4.75673 14.1844C3.55563 13.2135 2.72378 11.8601 2.4 10.35C2.14639 10.2272 1.93251 10.0354 1.78286 9.79663C1.63321 9.55787 1.55383 9.28179 1.55383 9C1.55383 8.71821 1.63321 8.44213 1.78286 8.20337C1.93251 7.96461 2.14639 7.77283 2.4 7.65C2.7107 6.12788 3.53692 4.75951 4.73927 3.77577C5.94162 2.79203 7.44649 2.25314 9 2.25C10.5 2.25 11.625 3.075 11.625 4.125C11.625 5.175 10.95 6 10.125 6C9.525 6 9 5.7 9 5.25",
    ],
  },
  loungewear_and_sleep: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 2.25C8.10489 3.14511 7.60203 4.35913 7.60203 5.625C7.60203 6.89087 8.10489 8.10489 9 9C9.89511 9.89511 11.1091 10.398 12.375 10.398C13.6409 10.398 14.8549 9.89511 15.75 9C15.75 10.335 15.3541 11.6401 14.6124 12.7501C13.8707 13.8601 12.8165 14.7253 11.5831 15.2362C10.3497 15.7471 8.99251 15.8808 7.68314 15.6203C6.37377 15.3599 5.17103 14.717 4.22703 13.773C3.28302 12.829 2.64015 11.6262 2.3797 10.3169C2.11925 9.00749 2.25292 7.65029 2.76381 6.41689C3.2747 5.18349 4.13987 4.12928 5.2499 3.38758C6.35993 2.64588 7.66498 2.25 9 2.25Z",
    ],
  },
  sparkles: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 2.25L7.566 6.60975C7.49261 6.83288 7.36785 7.03566 7.20175 7.20175C7.03566 7.36785 6.83288 7.49261 6.60975 7.566L2.25 9L6.60975 10.434C6.83288 10.5074 7.03566 10.6322 7.20175 10.7982C7.36785 10.9643 7.49261 11.1671 7.566 11.3903L9 15.75L10.434 11.3903C10.5074 11.1671 10.6322 10.9643 10.7982 10.7982C10.9643 10.6322 11.1671 10.5074 11.3903 10.434L15.75 9L11.3903 7.566C11.1671 7.49261 10.9643 7.36785 10.7982 7.20175C10.6322 7.03566 10.5074 6.83288 10.434 6.60975L9 2.25Z",
    ],
  },
  globe: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
      "M6 9C6 6.20756 7.07418 3.52212 9 1.5C10.9258 3.52212 12 6.20756 12 9C12 11.7924 10.9258 14.4779 9 16.5C7.07418 14.4779 6 11.7924 6 9Z",
      "M1.5 9H16.5",
    ],
  },
  truck: {
    size: 13,
    strokeWidth: 1.08333,
    paths: [
      "M7.58333 9.75V3.25C7.58333 2.96268 7.4692 2.68713 7.26603 2.48397C7.06287 2.2808 6.78732 2.16667 6.5 2.16667H2.16667C1.87935 2.16667 1.6038 2.2808 1.40063 2.48397C1.19747 2.68713 1.08333 2.96268 1.08333 3.25V9.20833C1.08333 9.35199 1.1404 9.48977 1.24198 9.59135C1.34357 9.69293 1.48134 9.75 1.625 9.75H2.70833",
      "M8.125 9.75H4.875",
      "M10.2917 9.75H11.375C11.5187 9.75 11.6564 9.69293 11.758 9.59135C11.8596 9.48977 11.9167 9.35199 11.9167 9.20833V7.23125C11.9164 7.10833 11.8744 6.98913 11.7975 6.89325L9.9125 4.537C9.86184 4.47356 9.79757 4.42232 9.72444 4.38707C9.65131 4.35181 9.57119 4.33345 9.49 4.33333H7.58333",
      "M9.20833 10.8333C9.80664 10.8333 10.2917 10.3483 10.2917 9.75C10.2917 9.15169 9.80664 8.66667 9.20833 8.66667C8.61002 8.66667 8.125 9.15169 8.125 9.75C8.125 10.3483 8.61002 10.8333 9.20833 10.8333Z",
      "M3.79167 10.8333C4.38998 10.8333 4.875 10.3483 4.875 9.75C4.875 9.15169 4.38998 8.66667 3.79167 8.66667C3.19336 8.66667 2.70833 9.15169 2.70833 9.75C2.70833 10.3483 3.19336 10.8333 3.79167 10.8333Z",
    ],
  },
  package: {
    size: 16,
    strokeWidth: 1.33333,
    paths: [
      "M5 2.84667L11 6.28",
      "M14 5.33333C13.9998 5.09952 13.938 4.86987 13.821 4.66744C13.704 4.46501 13.5358 4.29691 13.3333 4.18L8.66667 1.51333C8.46397 1.39631 8.23405 1.3347 8 1.3347C7.76595 1.3347 7.53603 1.39631 7.33333 1.51333L2.66667 4.18C2.46418 4.29691 2.29599 4.46501 2.17897 4.66744C2.06196 4.86987 2.00024 5.09952 2 5.33333V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667V5.33333Z",
      "M2.2 4.66667L8 8L13.8 4.66667",
      "M8 14.6667V8",
    ],
  },
  trend: {
    size: 16,
    strokeWidth: 1.33333,
    paths: [
      "M14.6667 4.66667L9 10.3333L5.66667 7L1.33333 11.3333",
      "M10.6667 4.66667H14.6667V8.66667",
    ],
  },
  "arrow-left": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M8 12.6667L3.33333 8L8 3.33333", "M12.6667 8H3.33333"],
  },
  "arrow-right": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M3.33333 8H12.6667", "M8 3.33333L12.6667 8L8 12.6667"],
  },
  check: {
    size: 12,
    strokeWidth: 1,
    paths: ["M10 3L4.5 8.5L2 6"],
  },
} satisfies Record<string, IconData>;

export type OnboardingIconName = keyof typeof ICONS;

type OnboardingIconProps = {
  name: OnboardingIconName;
  // Rendered size in px; defaults to the size it was drawn at in Figma.
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "name">;

export function OnboardingIcon({ name, size, ...props }: OnboardingIconProps) {
  const icon: IconData = ICONS[name];
  const renderedSize = size ?? icon.size;
  return (
    <svg
      width={renderedSize}
      height={renderedSize}
      viewBox={`0 0 ${icon.size} ${icon.size}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={icon.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}>
      {icon.paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
